import NewWorkoutEvent from './NewWorkoutEvent';

export default NewWorkoutEvent;
